var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66999 13.7855C7.67722 13.7938 7.68477 13.8018 7.69264 13.8097C7.73448 13.8515 7.78189 13.8844 7.83248 13.9083C8.01852 13.9977 8.24843 13.9653 8.40266 13.8111C8.41592 13.7978 8.42828 13.784 8.43974 13.7697L12.2888 9.9206C12.4841 9.72533 12.4841 9.40875 12.2888 9.21349C12.0936 9.01823 11.777 9.01823 11.5817 9.21349L8.54239 12.2528L8.54239 2.55281C8.54239 2.27667 8.31853 2.05281 8.04239 2.05281C7.76625 2.05281 7.54239 2.27667 7.54239 2.55281L7.54239 12.2437L4.51357 9.21488C4.31831 9.01962 4.00173 9.01962 3.80647 9.21488C3.6112 9.41014 3.6112 9.72672 3.80647 9.92199L7.66999 13.7855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRdown);
export default __webpack_public_path__ + "static/media/ic_arrow_rdown.329a593002102542d466daf9b8d80f14.svg";
export { ForwardRef as ReactComponent };